// extracted by mini-css-extract-plugin
export default {"napsa-header":"Header_napsa-header__pNadv","napsa-header__buttons":"Header_napsa-header__buttons__wBQ-7"};